module.exports = __webpack_public_path__ + "static/media/view.0d950ddc.svg";